import { extractErrorMessage as extractErrorMessageShared } from "@/shared/lib/errors";

export function formatMsToMmSs(timeMs: number) {
    const safe = Number.isFinite(timeMs) ? Math.max(0, timeMs) : 0;
    const mm = Math.floor((safe % 3600000) / 60000);
    const ss = Math.floor((safe % 60000) / 1000);
    return [mm, ss].map((v) => (v < 10 ? `0${v}` : String(v))).join(':');
}

export function digitsOnly(value: string) {
    return value.replace(/\D/g, '');
}

export function formatRussianMobileNumberMasked(d: string): string {
    if (!d) return '';
    const a = d.slice(0, 3);
    const b = d.slice(3, 6);
    const c = d.slice(6, 8);
    const e = d.slice(8, 10);
    let out = '(' + a;
    if (a.length === 3) out += ')';
    if (b.length) out += (a.length === 3 ? ' ' : '') + b;
    if (c.length) out += '-' + c;
    if (e.length) out += '-' + e;
    return out;
}

export function caretPosForNationalDigitIndex(formatted: string, digitIndex: number): number {
    if (digitIndex <= 0) return 0;
    let digitsSeen = 0;
    for (let i = 0; i < formatted.length; i++) {
        const ch = formatted[i];
        if (ch >= '0' && ch <= '9') {
            digitsSeen++;
            if (digitsSeen >= digitIndex) return i + 1;
        }
    }
    return formatted.length;
}

/** @deprecated Import from `@/shared/lib/errors` instead. */
export function extractErrorMessage(e: unknown, fallback: string): string {
    return extractErrorMessageShared(e, fallback);
}

export function formatE164RuToPretty(value: string): string {
    const d = digitsOnly(value);
    let national = d;
    if (national.length === 11 && (national.startsWith('7') || national.startsWith('8')))
        national = national.slice(1);
    if (national.length !== 10) return value;
    return `+7 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 8)}-${national.slice(8, 10)}`;
}
